export function type(target) {
  return [].concat(/\[object ([a-zA-Z]+)\]/.exec(Object.prototype.toString.call(target)) || [])[1];
}

function Is(typeName) {
  return function (target) {
    return type(target) === typeName;
  };
}
/**
 *
 * 判断一个变量是否是undefined
 * @export
 * @param {*} target
 * @returns {bool} 是否匹配
 * @example
 *
 * isUndefined(123) false
 * isUndefined(undefined) true
 */


export var isUndefined = Is('Undefined');
/**
 *
 * 判断一个变量是否是数组类型
 * @export
 * @param {*} target
 * @returns {bool} 是否匹配
 * @example
 *
 * isArray(123) false
 * isArray([132,321]) true
 */

export var isArray = Is('Array');
/**
 *
 * 判断一个变量是否是对象类型
 * @export
 * @param {*} target
 * @returns {bool} 是否匹配
 * @example
 *
 * isObject(123) false
 * isObject({}) true
 */

export var isObject = Is('Object');
/**
 *
 * 判断一个变量是否是字符串类型
 * @export
 * @param {*} target
 * @returns {bool} 是否匹配
 * @example
 *
 * isString(123) false
 * isString('32131') true
 */

export var isString = Is('String');
/**
 *
 * 判断一个变量是否是布尔类型
 * @export
 * @param {*} target
 * @returns {bool} 是否匹配
 * @example
 *
 * isBool(123) false
 * isBool(false) true
 */

export var isBool = Is('Boolean');
/**
 *
 * 判断一个变量是否是数字类型
 * @export
 * @param {*} target
 * @returns {bool} 是否匹配
 * @example
 *
 * isNumber(123) true
 * isNumber(false) false
 */

export var isNumber = Is('Number');
/**
 *
 * 判断一个变量是否是函数类型数
 * @export
 * @param {*} target
 * @returns {bool} 是否匹配
 * @example
 *
 * isFunction(123) false
 * isFunction(()=>{}) true
 */

export var isFunction = Is('Function');
/**
 *
 * 判断一个值是否是空对象，如果是空对象则返回true
 * @export
 * @param {*} target
 * @returns {bool} 是否匹配
 * @example
 *
 * isEmptyObject(123) false
 * isEmptyObject({}) true
 * isEmptyObject({a:123}) false
 */

export var isEmptyObject = function isEmptyObject(target) {
  if (isObject(target)) {
    return Object.keys(target).length === 0;
  }

  return false;
};